import { Constants } from '../../../constants/constants';
import { JustinoService } from '../../../services/justino.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';

@Component({
  selector: 'app-intro-justino',
  templateUrl: './intro-justino.component.html',
  styleUrl: './intro-justino.component.scss',
})
export class IntroJustinoComponent implements OnInit {
  codeIntro!: string;
  jusVersion: string = Constants.JUSTINO_VERSION;

  @Input() isAutehnticated!: string;
  @Output() entidadSeleccionada = new EventEmitter<string>();

  constructor(
    private justinoService: JustinoService,
    private alertService: AlertaModalService
  ) {
    this.codeIntro = '';
  }

  ngOnInit(): void {
    this.justinoService.getParameterByName(Constants.INTRO_PARAM).subscribe({
      next: data => {
        this.codeIntro = data.Value;
      },
      error: err => {
        console.error('Error loading parameter:', err);
        this.alertService.error(
          'Error',
          `No se pudo cargar el parámetro ${Constants.INTRO_PARAM}. Por favor, inténtelo de nuevo más tarde.`
        );
      },
    });
  }

  sendMessage(entityId: number) {
    let message = '';
    switch (entityId) {
      case 1:
        message = 'Identificar tipo de demanda.';
        break;
      case 2:
        message = 'Generar un borrador de la demanda.';
        break;
    }
    this.entidadSeleccionada.emit(message);
  }
}
